import { RefObject, useState, useEffect, DependencyList } from 'react'

export function useOverflowDetection<T extends HTMLElement>(ref: RefObject<T | null>, deps: DependencyList = []) {
  const [hasOverflow, setHasOverflow] = useState(false)

  useEffect(() => {
    const checkOverflow = () => {
      const element = ref.current

      if (element && element.clientHeight > 0) {
        setHasOverflow(element.scrollHeight > element.clientHeight)
      }
    }

    checkOverflow()
    window.addEventListener('resize', checkOverflow)

    return () => window.removeEventListener('resize', checkOverflow)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref, ...deps])

  return hasOverflow
}
